import { parseBilling, getActiveSubscriptions, hasRemoteMixPaidAddon } from '../../utils/stripe';

class UpdatePaymentController {
  constructor(
    $rootScope,
    $http,
    $uibModal,
    $timeout,
    $state,
    $q,
    Account,
    ActivationCodes,
    Order,
    MeetingsService,
    toaster,
    $scope
  ) {
    'ngInject';
    this.account = $rootScope.account;
    this.user = $rootScope.user;
    this.$http = $http;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.Account = Account;
    this.ActivationCodes = ActivationCodes;
    this.Order = Order;
    this.MeetingsService = MeetingsService;
    this.toaster = toaster;
    this.$state = $state;
    this.$scope = $scope;
    this.canEditPaymentSettings = $rootScope.user.can('update', 'billing');

    this.codes = this.ActivationCodes.query();

    this.accountExpired = moment(this.account.expires_on).toDate() < new Date();
    this.accountExpiresSoon = moment(this.account.expires_on).add(-30, 'day').toDate() < new Date();

    this.loadingPromises = [];
    this.isFree = this.account.contract == 'free' || this.account.contract == 'free2';
    this.vueDashboardRoot = $rootScope.vueDashboardRoot;

    this.reload();

    if (this.user.can('list', 'upgrades')) {
      this.loadingPromises.push(
        this.Account.getUpgrades((r) => {
          this.upgradesAvailable = r.filter((u) => !u.self_service);
        }).$promise
      );
    }

    this.loadingPromises.push(
      this.Order.query({ page: 1, page_size: 10 }, (result) => {
        this.orders = _.filter(result, (order) => order.status != 'cancelled');
      }).$promise
    );

    this.loading = true;
    $q.all(this.loadingPromises).finally(() => {
      this.loading = false;

      // Do scrolling if requested
      let params = $state.params;
      if (params.show_orders) {
        $timeout(() => {
          $('html, body').animate({ scrollTop: $('#shipment-history').offset().top - 90 });
        });
      }
    });

    // Check for passed-in parameters
    let params = $state.params;
    if (params.pd_did && params.pd_sid) {
      this.review(params.pd_did, params.pd_sid);
    } else if (params.action === 'checkout') {
      this.completeCheckout({});
    } else if (params.action === 'order_status') {
      $q.all(this.loadingPromises).then(() => {
        if (this.orders.length) {
          this.showOrderStatus(this.orders[0]);
        }
      });
    }
  }

  reload() {
    const { $http, toaster } = this;
    if (this.user.cannot('read', 'billing')) return;

    this.billing = this.Account.getBilling();
    this.billing.$promise
      .then(async () => {
        var billingResult = parseBilling(this.billing);
        const default_pm_id = await this.$http
          .post(`${API_ROOT}/stripe/list_default_payment_method`, {})
          .then((response) => {
            return response.data.default_payment_method_id;
          });
        if (default_pm_id) {
          const pm = await this.$http
            .post(`${API_ROOT}/stripe/retrieve_payment_method`, {
              payment_method_id: default_pm_id,
            })
            .then((response) => {
              return response.data.payment_method;
            });
          this.cardOnFile = {
            bank_name: pm.us_bank_account.bank_name,
            last4: pm.us_bank_account.last4,
          };
        } else {
          this.cardOnFile = billingResult.cardOnFile || billingResult.bankOnFile;
        }
        this.paidInvoices = billingResult.paidInvoices;
        this.outstandingInvoices = billingResult.outstandingInvoices;
        this.daysUntilSuspend = billingResult.daysUntilSuspend;
        this.subscriptions = billingResult.subscriptions;
        this.isBilledMonthly = billingResult.isBilledMonthly;
        this.formattedAddress = billingResult.formattedAddress;
        this.isPremium = billingResult.isPremiumPlan;
      })
      .catch((err) => {
        if (err.status == 404) {
          // No Stripe customer for this account
        } else {
          console.error(err);
          toaster.pop(
            'warning',
            'Unable to load your current payment information. Please reload this page and try again.'
          );
        }
      });

    this.loadingPromises.push(this.billing.$promise);
  }

  showEditPaymentModal() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('./modal-edit-payment.html'),
      controller: require('./modal-edit-payment.js').default,
      controllerAs: 'vm',
      resolve: {
        parentVM: () => parentVM,
      },
      //  Prevent accidental close...
      keyboard: false,
      backdrop: 'static',
    });
  }

  showActivationModal() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('./modal-enter-activation-code.html'),
      controller: function ($scope, $rootScope, $uibModalInstance, toaster, ActivationCodes) {
        'ngInject';

        $scope.toaster = toaster;
        $scope.ActivationCodes = ActivationCodes;
        $scope.codes = angular.copy(parentVM.codes);

        $scope.validateAndUseActivationCode = () => {
          $scope.activating = true;

          $scope.activation_code = $scope.formatActivationCode($scope.activation_code || '');
          if ($scope.activation_code.length !== 24) {
            $scope.activating = false;
            $scope.toaster.pop('warning', 'Invalid activation code.');
            return;
          }

          $scope.ActivationCodes.activateAddon({ id: $scope.activation_code }).$promise.then(
            (data) => {
              $scope.activating = false;
              $scope.toaster.pop('success', 'Successfully activated.');
              window.location = window.location.href.split('?')[0];
              window.location.reload();
              return;
            },
            (err) => {
              console.error(err);
              $scope.activating = false;
              $scope.toaster.pop(
                'warning',
                `Unable to activate code. ${err.data.error_description}`
              );
              return;
            }
          );
        };

        $scope.formatActivationCode = (id) => {
          try {
            return id.split('-').join('').match(new RegExp('.{1,4}', 'g')).join('-').toUpperCase();
          } catch (e) {
            return id;
          }
        };

        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
      },
    });
  }

  doChangePlan() {
    let checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout';
    if (this.account.metadata.remote_mix_sign_up === true) {
      const activeSubscriptions = getActiveSubscriptions(this.billing);
      const isTrial = this.account.contract === 'trial';
      // if they are RemoteMix originated account and are either on a trial, or have not yet paid for the RemoteMix addon, then we need to send them to the RemoteMix checkout flow
      if (isTrial || !hasRemoteMixPaidAddon(activeSubscriptions)) {
        checkoutURL += '/remote-mix';
      }
    }
    window.location.href = checkoutURL;
  }

  doPurchaseAddons() {
    let checkoutURL = window.VUE_DASHBOARD_ROOT + '/checkout?start_step=add-on';
    window.location.href = checkoutURL;
  }

  onLetsChat() {
    if (window.Intercom) {
      window.Intercom('show');
    }
  }

  canChat() {
    return !!window.Intercom;
  }

  showCheckInstructions() {
    const { $uibModal } = this;

    $uibModal.open({
      template: require('./modal-check-instructions.html'),
      controller: function ($scope, $uibModalInstance) {
        'ngInject';
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
      },
    });
  }

  showPurchaseOrderInstructions() {
    const { $uibModal } = this;

    $uibModal.open({
      template: require('./modal-po-instructions.html'),
      controller: function ($scope, $uibModalInstance) {
        'ngInject';
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
      },
    });
  }

  review(pd_did, pd_sid) {
    const { account } = this;
    const params = { pd_did: pd_did, pd_sid: pd_sid };
    if (!account.isTrialing()) {
      params.is_upgrade = true;
    }
    this.completeCheckout(params);
  }

  completeCheckout(params) {
    const { $scope } = this;
    let checkoutURL =
      window.VUE_DASHBOARD_ROOT + `/checkout?pd_did=${params.pd_did}&pd_sid=${params.pd_sid}`;
    window.location.href = checkoutURL;
    $scope.$on('$destroy', () => {
      if (instance) instance.close();
    });
  }

  showOrderStatus(order) {
    this.$uibModal.open({
      template: require('./modal-order-status.html'),
      resolve: {
        order: () => order,
        account: () => this.account,
        showOrdersLink: () => false,
      },
      controller: require('./modal-order-status').default,
      controllerAs: 'vm',
    });
  }

  showUsageSummary(subscriptionItemId, plan, periodStart, periodEnd) {
    this.$uibModal.open({
      template: require('./modal-usage-summary.html'),
      resolve: {
        subscriptionItemId: () => subscriptionItemId,
        plan: () => plan,
        periodStart: () => periodStart,
        periodEnd: () => periodEnd,
      },
      controller: require('./modal-usage-summary').default,
      controllerAs: 'vm',
    });
  }
}

export default UpdatePaymentController;



// WEBPACK FOOTER //
// ./app/pages/settings/payment.js